import * as React from 'react';

function SvgConsultant(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M0 0h24v24H0z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 4H4v9h5v6h12v-8h-4V4z"
        fill={props?.fColor ?? '#FCCE01'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 2.85H1.85v12.685l3.313-3.112H16.15V2.85H13a.85.85 0 010-1.7h3.8c.58 0 1.05.47 1.05 1.05v5.95h4.95c.58 0 1.05.47 1.05 1.05v13.566c0 .836-1.001 1.265-1.606.688l-3.585-3.422H9.2c-.58 0-1.05-.47-1.05-1.05v-4.86H5.837l-4.087 3.84c-.606.569-1.6.139-1.6-.693V2.2c0-.58.47-1.05 1.05-1.05H9a.85.85 0 110 1.7zm.85 11.273v4.209h9.49l2.81 2.682V9.85h-4.3v3.223c0 .58-.47 1.05-1.05 1.05H9.85zM5 6.15c0-.47.38-.85.85-.85h6.3a.85.85 0 010 1.7h-6.3A.85.85 0 015 6.15zm.85 2.15a.85.85 0 000 1.7h6.3a.85.85 0 100-1.7h-6.3z"
        fill="#595959"
      />
    </svg>
  );
}

export default SvgConsultant;
